import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'nameToCharacters',
})
export class NameToCharactersPipe implements PipeTransform {
  transform(value: string, ...args: unknown[]): string {
    if (!value) return 'Unknown User Name';
    const nameParts = value.trim().split(' ');
    let initials = '';

    if (nameParts.length > 1) {
      initials =
        nameParts[0].charAt(0) + nameParts[nameParts.length - 1].charAt(0);
    } else if (nameParts.length === 1) {
      initials = nameParts[0].substring(0, 2);
    }

    return initials.toUpperCase();
  }
}
